import React from 'react';
import { Controller } from 'react-hook-form';
import { Stack, FormControlLabel, Switch, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import NumberTextField from '@v2/components/ui/NumberTextField/NumberTextField';
import { fields } from '../constants';
import { MaxCpmType } from './types';

export const MaxCpm = ({
  control,
  required = false,
  label,
  handleCPMSwitchChange,
  isMaxCPMBidEnabled,
  rangeText,
}: MaxCpmType) => (
  <Stack>
    {!required && (
      <FormControlLabel
        control={
          <Controller
            control={control}
            name={fields.maxCPMBidEnabled.path}
            render={({ field }) => (
              <Switch
                {...field}
                color="primary"
                checked={!!field.value}
                onChange={handleCPMSwitchChange}
                data-testid="max-cpm-switch"
              />
            )}
          />
        }
        label={label ?? 'Set Max CPM Bid (optional)'}
        labelPlacement="end"
        sx={{ marginRight: 'auto', marginBottom: 2.5 }}
      />
    )}
    {(isMaxCPMBidEnabled || required) && (
      <Stack
        direction="row"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: 1.25,
        }}
      >
        <Controller
          name={fields.maxCPMBid.path}
          control={control}
          render={({ field, fieldState }) => (
            <NumberTextField
              {...field}
              {...fieldState}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              label={label ?? 'Max CPM Bid'}
              variant="outlined"
              sx={{ marginRight: 2.5 }}
            />
          )}
        />
        <InfoIcon sx={{ color: 'action.active' }} />
        <Typography sx={{ marginLeft: 1.25 }}>
          The recommended bid range for your inventory selection is{' '}
          {rangeText}.
        </Typography>
      </Stack>
    )}
  </Stack>
);
